<template>
    <div class="text-block-bullet-list">
		<div
		v-for="(item, index) in parsedList"
		:key="`item-${index}`"
		class="list-item">
            <div class="content-wrapper">
                <span v-if="isNumbered" class="circle with-number">{{index+1}}</span>
                <span v-else class="circle"/>
                <div class="item-text" v-html="item.replaceAll('\\n', '<br>').replaceAll('\n', '<br>')" :class="{'with-number': isNumbered}"/>
            </div>
            <div class="slot-wrapper">
                <slot :name="`item-slot-${index+1}`"/>
            </div>
		</div>
	</div>
</template>

<script setup>
/* Vue */
import { computed } from 'vue'
/* Props
@list {Array, Object} - Array or Object which we will iterate to create our bullet list
@isNumbered {Boolean} - Prop to apply number in bullet, and apply the correct styles for that
*/
const props = defineProps({
	list: [Array, Object],
    isNumbered: Boolean
})

const parsedList = computed(() => {
    if (Array.isArray(props.list)) return props.list
    return Object.values(props.list)
})
</script>

<style lang="scss" scoped>
.text-block-bullet-list {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 16px;

    .list-item {
        width: 100%;

        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;

        .content-wrapper {
            width: 100%;

            display: flex;
            align-items: flex-start;
            justify-content: flex-start;

            .circle {
                width: 4px;
                height: 4px;
                margin: 8px 8px 0 0;

                flex-shrink: 0;

                border-radius: 50%;
                background-color: var(--primary);

                &.with-number {
                    width: 24px;
                    height: 24px;
                    margin-top: 0px;

                    @include H8-Regular;
                    color: var(--secondary-light-2);
                    line-height: 24px;
                    text-align: center;
                }
            }

            .item-text {
                @include H6-Regular;
                line-height: 18px;
                color: var(--secondary-dark-2);

                a, a:hover {
                    color: var(--primary);
                }

                &.with-number {
                    @include H5-Medium;
                    line-height: 20px;
                }
            }
        }

        .slot-wrapper {
            width: 100%;
            padding-left: 32px;
        }
    }
}
</style>
